import { useState, useEffect } from "react";
import { useLocation, matchPath } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "./responsive.css";
import { getPath } from "./utils/constants";

// Pages
import Home from "./pages/Home";
import UniverseKembarPintar from "./pages/UniverseKembarPintar";
import StoryBook from "./pages/StoryBook";
import AboutUs from "./pages/AboutUs";
import Contact from "./pages/Contact";
import PageNotFound from "./pages/PageNotFound"; // Import NotFound component

// Components
import PageWrapper from "./components/PageWrapper";

const routes = [
  { path: getPath("home"), element: <Home /> },
  { path: getPath("siKembarPintar"), element: <UniverseKembarPintar /> },
  { path: getPath("storyBook"), element: <StoryBook /> },
  { path: getPath("about"), element: <AboutUs /> },
  { path: getPath("contact"), element: <Contact /> },
];

const PageTransitionManager = () => {
  const location = useLocation();
  const [displayLocation, setDisplayLocation] = useState(location);
  const [transitionStage, setTransitionStage] = useState("fadeIn");

  useEffect(() => {
    // Check if the location has changed
    if (location.pathname !== displayLocation.pathname) {
      const scrollableElement = document.querySelector('.App');
      if (scrollableElement) {
        const scrollTop = scrollableElement.scrollTop;
        // Use querySelector which is a bit safer than getElementsByClassName[0]
        const oldPageContent = document.querySelector('.page-wrapper > div');
        if (oldPageContent) {
          oldPageContent.style.marginTop = `-${scrollTop}px`;
        }
        scrollableElement.scrollTo(0, 0);
      }
      setTransitionStage("fadeOut");
    } else {
      // Force a transition if clicking the same route
      setTransitionStage("fadeIn");
    }
  }, [location, displayLocation]);

  // Match the current route
  const matchedNew = routes.find((route) => matchPath(route.path, location.pathname));

  // Match the previous route
  const matchedOld = routes.find((route) => matchPath(route.path, displayLocation.pathname));

  // If no match is found, we handle it as the 404 page
  const isPageNotFound = !matchedNew;

  return (
    <div style={{ position: "relative", minHeight: "100vh" }}>
      <AnimatePresence
        initial={false}
        mode="sync"
        onExitComplete={() => {
          setDisplayLocation(location);
          setTransitionStage("fadeIn");
        }}
      >
        {transitionStage === "fadeOut" && matchedOld && <PageWrapper key={displayLocation.pathname}>{matchedOld.element}</PageWrapper>}

        {transitionStage === "fadeIn" &&
          (isPageNotFound ? (
            <PageWrapper key={location.pathname}>
              <PageNotFound /> {/* Display PageNotFound if no match is found */}
            </PageWrapper>
          ) : (
            matchedNew && <PageWrapper key={location.pathname}>{matchedNew.element}</PageWrapper>
          ))}
      </AnimatePresence>
    </div>
  );
};

export default PageTransitionManager;
